import { isNil } from 'ramda';
import { MediaData } from '~admin/model/media-data';
import { AdminMediaResponse } from '~client/model/admin/admin-media-response';

export const mapMediaData = (response: AdminMediaResponse): MediaData => {
  if (isNil(response)) {
    return null;
  }

  const { id, url, longDescription, width, height, mediaType } = response;

  return {
    id: Number(id),
    url,
    description: longDescription,
    width,
    height,
    type: mediaType,
  };
};

export const mapMediaDataList = (response: AdminMediaResponse[]): MediaData[] =>
  response.map(mapMediaData);



// WEBPACK FOOTER //
// ./model/media-data.mapper.ts